<template>
  <v-card style='text-align:left'>

    <v-layout row v-if="!person.note || (person.note.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>General Notes</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("note", -1, { v: "" })'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>General Notes</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(note, index) in person.note" v-bind:key="note.rid">
          <v-flex xs8 mx-2>
            <v-textarea v-focus autofocus v-model="note.v" name='note' rows="2" :rules="[ needed ]" /> 
          </v-flex>
          <v-flex xs4 pt-3>
            <v-icon  small  @click='delProp("note", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("note", index, { v: "" })'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.note, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.note.length - 1)"  small  @click='down(person.note, index)'>arrow_downward</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.noteFamily || (person.noteFamily.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Family Notes</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("noteFamily", -1, { v: "" })'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Family Notes</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start v-for="(noteFamily, index) in person.noteFamily" v-bind:key="noteFamily.rid">
          <v-flex xs8 mx-2>
            <v-textarea v-focus autofocus v-model="noteFamily.v" name='noteFamily' rows="2" :rules="[ needed ]" /> 
          </v-flex>
          <v-flex xs4 pt-3>
            <v-icon  small  @click='delProp("noteFamily", index)' >delete</v-icon>
            <v-icon  small @click='addMultiOccuringProp("noteFamily", index, { v: "" })'>add</v-icon>
            <v-icon v-if="index > 0"  small   @click='up(person.noteFamily, index)'>arrow_upward</v-icon>
            <v-icon v-if="index < (person.noteFamily.length - 1)"  small  @click='down(person.noteFamily, index)'>arrow_downward</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.noteCwgMatch || (person.noteCwgMatch.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>CWG Match Notes</label><v-btn flat fab  small mt-4  middle 
        @click='addSinglyOccuringNoncodeProp("noteCwgMatch", { v: "" })'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>CWG Match Notes</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row >
          <v-flex xs8 mx-2 justify-start>
            <v-textarea v-focus autofocus v-model="person.noteCwgMatch.v" name='noteCwgMatch' rows="2" :rules="[ needed ]" /> 
          </v-flex>
          <v-flex xs4 pt-3>
            <v-icon  small  @click='delProp("noteCwgMatch")' >delete</v-icon>
             </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  

    <v-layout row v-if="!person.noteNaamatch || (person.noteNaamatch.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>NAA Match Note</label><v-btn flat fab  small mt-4  middle 
        @click='addSinglyOccuringNoncodeProp("noteNaamatch", { v: "" })'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>NAA Match Notes</label>
      </v-flex>
      <v-flex xs10>
        <v-layout row justify-start>
          <v-flex xs8 mx-2>
            <v-textarea v-focus autofocus v-model="person.noteNaamatch.v" name='noteNaamatch' rows="2" :rules="[ needed ]" /> 
          </v-flex>
          <v-flex xs4 pt-3>
            <v-icon  small  @click='delProp("noteNaamatch")' >delete</v-icon>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>  
   
    <v-layout row v-if="!person.naaLink || (person.naaLink.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>NAA References</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("naaLink", -1, {barcode: "", description: "", type: "record", series: naaSeriesValues[0]})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>NAA References</label>
      </v-flex>
      <v-flex xs10>
        <v-layout column justify-start v-for="(naaLink, index) in person.naaLink" v-bind:key="naaLink.rid">
          <v-flex xs12 >
            <v-layout>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs4 mx-2>
                     <v-text-field v-focus autofocus v-model="naaLink.barcode"  label="Barcode" :rules="[ isABarcode ]"></v-text-field>
                  </v-flex>
                  <v-flex xs4 mx-2>
                     <v-combobox v-model="naaLink.series" :items="naaSeriesValues" label="Series" :rules="[ needed ]"></v-combobox>
                     <v-select v-model="naaLink.type" :items="naaTypeValues" label="Type" :rules="[ needed ]"></v-select>
                     <v-text-field v-model="naaLink.description" label="Description"></v-text-field>
                  </v-flex>

                  <v-flex xs4 pt-3>
                    <v-icon  small  @click='delProp("naaLink", index)' >delete</v-icon>
                    <v-icon  small @click='addMultiOccuringProp("naaLink", index, {barcode: "", description: "", type: "", series: ""})'>add</v-icon>
                    <v-icon v-if="index > 0"  small   @click='up(person.naaLink, index)'>arrow_upward</v-icon>
                    <v-icon v-if="index < (person.naaLink.length - 1)"  small  @click='down(person.naaLink, index)'>arrow_downward</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout> 

    <v-layout row v-if="!person.image || (person.image.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Image</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("image", -1, {type: "", caption: "", description: "", filename: null, role:"", photographer:""})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Image</label>
      </v-flex>
      <v-flex xs10>
        <v-layout column justify-start v-for="(image, index) in person.image" v-bind:key="image.rid">
          <v-flex xs12 >
            <v-layout>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs4 mx-2>
                     <v-text-field v-focus autofocus v-model="image.caption"  label="Caption"></v-text-field>
                     <template v-if="image.rid > 0">                      
                       <img v-bind:src='$imageBaseURL + image.filename' style='width:200px'/>
                     </template>
                  </v-flex>
                  <v-flex xs4 mx-2>
                     <v-combobox v-model="image.type"  label="Type" :items="imageTypeValues"  :rules="[ needed ]"></v-combobox>                    
                     <v-text-field v-model="image.description" label="Description"></v-text-field>
                     <v-text-field v-model="image.photographer" label="Photographer"></v-text-field>
                     <template v-if="image.rid < 0">  <!-- only new images.. -->
                       <input type="file" ref="image" accept="image/*" @change="onFileChange($event, index)"/>
                       <img v-bind:src="image.preview" style="display:flex;width:150px"/>
                     </template>                     
                  </v-flex>

                  <v-flex xs4 pt-3>
                    <v-icon  small  @click='delProp("image", index)' >delete</v-icon>
                    <v-icon  small @click='addMultiOccuringProp("image", index, {type: "", caption: "", description: "", filename: null, role:"", photographer:""})'>add</v-icon>
                    <v-icon v-if="index > 0"  small   @click='up(person.image, index)'>arrow_upward</v-icon>
                    <v-icon v-if="index < (person.image.length - 1)"  small  @click='down(person.image, index)'>arrow_downward</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>     

    <v-layout row v-if="!person.link || (person.link.length < 1)">
      <v-flex offset-xs9 xs3>
        <label class='prompt'>Other Links</label><v-btn flat fab  small mt-4  middle 
        @click='addMultiOccuringProp("link", -1, {prompt: "", url: "", description: ""})'  ><v-icon>add</v-icon></v-btn> 
      </v-flex>
    </v-layout>
    <v-layout row v-else>
      <v-flex xs2 pt-3  mx-2> 
          <label class='prompt'>Link</label>
      </v-flex>
      <v-flex xs10>
        <v-layout column justify-start v-for="(link, index) in person.link" v-bind:key="link.rid">
          <v-flex xs12 >
            <v-layout>
              <v-flex xs12>
                <v-layout>
                  <v-flex xs4 mx-2>
                     <v-text-field v-focus autofocus v-model="link.prompt"  label="Link text"></v-text-field>                   
                  </v-flex>
                  <v-flex xs4 mx-2>
                     <v-text-field v-model="link.url" label="URL"></v-text-field>                    
                     <v-text-field v-model="link.description" label="Description"></v-text-field>                    
                  </v-flex>                  
                  <v-flex xs4 pt-3>
                    <v-icon  small  @click='delProp("link", index)' >delete</v-icon>
                    <v-icon  small @click='addMultiOccuringProp("link", index, {prompt: "", url: "", description: ""})'>add</v-icon>
                    <v-icon v-if="index > 0"  small   @click='up(person.link, index)'>arrow_upward</v-icon>
                    <v-icon v-if="index < (person.link.length - 1)"  small  @click='down(person.link, index)'>arrow_downward</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>   

  </v-card>
</template>        

<script>

export default {

  components: { },
  props: {
    person: null
  },

  data () {
    return {
      addSeqForRid: -1,
      naaTypeValues: ['no', 'record', 'photo'],
      naaSeriesValues: ['A6769', 'A6770', 'A705', 'A8231', 'A9300', 'A9301', 'AWM65', 'B4747', 'B883', 'BP751/1'],
      imageTypeValues: ['cemetery', 'childhood', 'commemoration', 'family', 'identity photo', 'memorial', 'post-war', 'war time']
    }
  },

  methods: {

    onFileChange (evt, ix) {
      console.log("onFileChange event=" + evt + ", file=" + evt.target.files[0] + " ix=" + ix) ;
      const image = evt.target.files[0] ;
      this.$set(this.person.image[ix], "preview", URL.createObjectURL(image)) ;
      const reader = new FileReader() ;
      reader.readAsDataURL(image) ;
      reader.onload = evt => { 
        console.log("setting person image preview " + ix + " to " + evt.target.result) ;        
        this.person.image[ix].contents = evt.target.result ;
        // this.$forceUpdate() ;   // shouldnt have to do this.
      } ;
    },
    finaliseUpdates () {

      console.log("===========================> linkstab finaliseUpdates") ;
    },

    needed (value) {
      console.log(" in needed, value is " + value)  ;
      if (value && value.length && (value.length > 0)) return true ;
      this.$emit('errorOnTab') ; 
      console.log("emmitted swap") ;
      return "Required" ;
    },

    isABarcode (value) {
      console.log(" in isABarcode, value is " + value)  ;
      const bc = parseInt(value, 10) ;
      if ((bc > 99999) && (bc <= 99999999)) return true ;
      this.$emit('errorOnTab') ; 
      console.log("emmitted swap") ;
      return "Must be a 6, 7 or 8 digit number" ;
    },

    addMultiOccuringProp (propName, index, record, propCode, defaultValue) {  // addMultiOccuringProp("otherNames", -1, {surname: "", firstNames: ""})

      if (!this.person[propName]) this.person[propName] = [] ;
      var newRec ;
      if (record) newRec = { ...record, rid: this.addSeqForRid-- } ; // a unique rid so as not to confuse keys - but it will be negative, so backend knows it is new
      else  {
        newRec = {...this.setDefaultOption(propCode, defaultValue), rid: this.addSeqForRid--} ;
      }
      
      console.log("in addMultiOccuringProp " + record + " newRec " + JSON.stringify(newRec)) ;

      this.person[propName].splice(index + 1, 0, newRec) ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    addDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      this.person[propName][index].scopeFrom = "1900-01-01" ;
      this.person[propName][index].scopeTo = "1900-12-31" ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    delDateRange (propName, index) {
      console.log("adding date range to " + propName + " at " + index) ;
      delete this.person[propName][index].scopeFrom  ;
      delete this.person[propName][index].scopeTo ;
      this.$forceUpdate() ;   // shouldnt have to do this.
    },

    up (arr, ix) {  // take entry at ix and move it to ix-1
      console.log("UpA " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix - 1] ;
      arr[ix - 1] = x ;
      console.log("UpB " + ix + "  arr:" + JSON.stringify(this.person.otherNames)) ; 
      this.$forceUpdate() ;

    },
    down (arr, ix) {
      console.log("downA " + ix + "  arr:" + JSON.stringify(arr)) ; 
      var x = arr[ix] ;
      arr[ix] = arr[ix + 1] ;
      arr[ix + 1] = x ;
      console.log("downB " + ix + "  arr:" + JSON.stringify(arr)) ; 
      this.$forceUpdate() ;
    },

    setDefaultOption (codeType, defaultValue) {
      const glist = this.$constants.codeValues[codeType] ; 
      for (var i = 0 ; i < glist.length ; i++) {
        if (glist[i].v === defaultValue) {
          return { v: glist[i].v, id: glist[i].id } ;
        }
      }
      return { v: "No default", id: -1 } ;
    },

    delProp (propName, index) {
      console.log("Del prop name " + propName + " index " + index) ;
      if (index >= 0) this.person[propName].splice(index, 1) ;
      else delete this.person[propName] ;
      this.$forceUpdate() ;
    },

    addSinglyOccuringNoncodeProp (propName, defaultValue) {
      this.person[propName] = defaultValue ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    addSinglyOccuringCodeProp (propName, propCode, defaultValue) {  
      this.person[propName] = [ this.setDefaultOption(propCode, defaultValue) ] ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/LinksTab.vue